import React, { useRef, useState } from 'react';

import styles from '../../../PrimaryNavigation.module.scss';
import {
  Input,
  Text,
  MenuItem,
  MenuSection,
  MenuHeader,
  MenuList,
  MenuSeparator,
} from 'components/core';
import { useDebouncedFunction } from 'hooks/useDebouncedFunction';
import { validateEmail } from 'util/validateEmail';

interface Props {
  isAdmin: boolean;
  canProxy: boolean;
  className?: string;
}
type FieldState = 'pristine' | 'valid' | 'invalid';

const ProxyEmailField = () => {
  const [valid, setValid] = useState<FieldState>('pristine');

  const debounced = useDebouncedFunction((emailValid) => {
    setValid(emailValid ? 'valid' : 'invalid');
  }, 200);

  const inputRef = useRef<HTMLInputElement>(null);

  const onChange = () => {
    const field = inputRef.current as HTMLInputElement;
    const emailValid = validateEmail(field.value);
    debounced(emailValid);
  };

  return (
    <div>
      <Input
        ref={inputRef}
        inputType="email"
        name="email"
        placeholder="proxy@email.com"
        onInput={onChange}
        type={valid == 'invalid' ? 'danger' : 'neutral'}
      />
      {valid == 'invalid' ? (
        <div style={{ color: 'red' }}>Email is invalid</div>
      ) : null}
    </div>
  );
};

const AdminSection = ({ isAdmin, canProxy }: Props) => {
  if (!isAdmin) {
    return null;
  }

  return (
    <>
      <MenuSeparator />
      <MenuList aria-label="Admin controls">
        <MenuSection>
          <MenuHeader>
            <Text
              size="xs"
              variant="weak"
              className={styles.PrimaryNavigation_paddingMenu}
            >
              Admin controls
            </Text>
          </MenuHeader>
          <MenuItem href="/admin">Admin</MenuItem>
          <MenuItem href="/admin/background-jobs">Background queues</MenuItem>
        </MenuSection>
      </MenuList>
      {/* Static elements must be outside the MenuList */}
      {canProxy && (
        <form
          action="/proxy_as"
          method="get"
          className={styles.ProxyForm}
          tabIndex={-1}
        >
          <ProxyEmailField />
        </form>
      )}
    </>
  );
};

export default AdminSection;
